// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#project-info .admissionMonthCode.MuiAutocomplete-root .form-control {\n    padding: 0;\n}\n\n#project-info .admissionMonthCode.MuiAutocomplete-root .form-control[readonly] {\n    background: inherit;\n}\n\n#project-info .admissionMonthCode .MuiAutocomplete-inputRoot .MuiAutocomplete-input {\n    padding: 0 4px;\n    font-size: 14px;\n}\n\n#project-info .admissionMonthCode .MuiAutocomplete-inputRoot[class*=\"MuiOutlinedInput-root\"] {\n    padding: 0;\n    min-height: 31px;\n}", ""]);
// Exports
module.exports = exports;
